import React from "react";
import Plot from "react-plotly.js";

const BandWiseDotChart = ({ data, is3D = false, xAxisName, yAxisName }) => {
    const markerStyle = {
        size: 8,
        color: "#1f77b4",
        opacity: 0.8,
    };

    const trace2D = {
        x: data.map((d) => d.x),
        y: data.map((d) => d.y),
        mode: "markers",
        type: "scatter",

        marker: {
            size: data.map((d) => d.value * 20),
            color: data.map((d) => d.value),
            colorscale: "Viridis",
            // showscale: true,
            // colorbar: { title: "Value" },
        },
        text: data.map((d) => `Value: ${d.value} kWh/km`),
        hovertemplate: "X: %{x}<br>Y: %{y}<br>%{text}<extra></extra>",
    };

    const trace3D = {
        x: data.map((d) => d.x),
        y: data.map((d) => d.y),
        z: data.map((d) => d.value),
        mode: "markers",
        type: "scatter3d",
        marker: markerStyle,
        marker: {
            size: data.map((d) => d.value * 10),
            color: data.map((d) => d.value),
            colorscale: "Viridis",
            showscale: true,
            colorbar: { title: "Value" },
            opacity: 0.8,
        },
        text: data.map((d) => `Value: ${d.value}`),
        hovertemplate:
            "X: %{x}<br>Y: %{y}<br>Z (Value): %{z}<extra></extra>",
    };

    const layout2D = {
        xaxis: { title: xAxisName, type: "category", titlefont: { size: 10 }, standoff: 10, },
        yaxis: { title: yAxisName, type: "category", titlefont: { size: 10 }, standoff: 18, automargin: true, },
        plot_bgcolor: "#f8f9fa",
        paper_bgcolor: "#fff",
        hovermode: "closest",
        width: 900,
        height: 500,
        margin: { l: 60, t: 10 },
        dragmode: false,
    };

    const layout3D = {
        title: "Band-wise Dot (3D Bubble) Chart",
        scene: {
            xaxis: { title: "Speed" },
            yaxis: { title: "Acceleration" },
            zaxis: { title: "Value" },
        },
        plot_bgcolor: "#f8f9fa",
        paper_bgcolor: "#fff",
    };

    return (
        <Plot
            data={[is3D ? trace3D : trace2D]}
            layout={is3D ? layout3D : layout2D}
            config={{
                responsive: true,
                displayModeBar: false, // hides the toolbar completely
                scrollZoom: false,      // disables zoom
                doubleClick: false,     // disables double-click reset
                staticPlot: false,      // allow hover but disable drag/zoom/pan
                displaylogo: false,     // remove Plotly logo
                editable: false,
            }}
        />
    );
};

export default BandWiseDotChart;

